// extracted by mini-css-extract-plugin
export default {"LogoList":"fGgJ9orE47RUQhBwqVMU"};